import { render, staticRenderFns } from "./MaterialsTable.vue?vue&type=template&id=371005de&scoped=true"
import script from "./MaterialsTable.vue?vue&type=script&lang=js"
export * from "./MaterialsTable.vue?vue&type=script&lang=js"
import style0 from "./MaterialsTable.vue?vue&type=style&index=0&id=371005de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371005de",
  null
  
)

export default component.exports